module.exports = __webpack_public_path__ + "img/equipment-category.e4bf0a11.svg";